import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', {
  state: () => ({
    items: JSON.parse(localStorage.getItem('cart')) || []
  }),

  getters: {
    cartCount: (state) => {
      return state.items.reduce((total, item) => total + item.quantity, 0)
    },
    
    cartTotal: (state) => {
      return state.items.reduce((total, item) => total + (item.price * item.quantity), 0)
    },

    cartItems: (state) => state.items
  },

  actions: {
    addToCart(cartItem) {
      // Handle both new structure (cartItem object) and legacy structure
      let itemData
      
      if (cartItem.product) {
        // New structure from ProductDetail component
        itemData = {
          id: cartItem.product._id || cartItem.product.id,
          name: cartItem.product.name,
          price: cartItem.price,
          image: cartItem.product.images?.[0]?.url || cartItem.product.image,
          size: cartItem.size,
          quantity: cartItem.quantity,
          sku: cartItem.product.sku,
          category: cartItem.product.category
        }
      } else {
        // Legacy structure for backward compatibility
        itemData = {
          id: cartItem.id,
          name: cartItem.name,
          price: cartItem.price,
          image: cartItem.image,
          size: cartItem.size || 'Standard',
          quantity: cartItem.quantity || 1,
          sku: cartItem.sku,
          category: cartItem.category
        }
      }

      const existingItem = this.items.find(item => 
        item.id === itemData.id && item.size === itemData.size
      )

      if (existingItem) {
        existingItem.quantity += itemData.quantity
      } else {
        this.items.push(itemData)
      }

      this.saveToLocalStorage()
    },

    removeFromCart(itemId, size) {
      this.items = this.items.filter(item => 
        !(item.id === itemId && item.size === size)
      )
      this.saveToLocalStorage()
    },

    updateQuantity(itemId, size, quantity) {
      const item = this.items.find(item => 
        item.id === itemId && item.size === size
      )
      
      if (item) {
        if (quantity <= 0) {
          this.removeFromCart(itemId, size)
        } else {
          item.quantity = quantity
          this.saveToLocalStorage()
        }
      }
    },

    clearCart() {
      this.items = []
      this.saveToLocalStorage()
    },

    saveToLocalStorage() {
      localStorage.setItem('cart', JSON.stringify(this.items))
    }
  }
}) 